import { mapState } from 'vuex';
import { parseISO, format } from 'date-fns';
// import axios from 'axios';
import { Message } from 'element-ui';

// import { getBearerToken } from '@/api/gateway';

const PREVIEW_FILE_TYPES = ['jpg', 'jpeg', 'png', 'pdf'];

// const DEBUG_ROLE = 'CUSTOMER';
// const DEBUG_ROLE = 'PROJECT_MANAGER';
// const DEBUG_ROLE = 'CREATOR';

export default {
  computed: {
    ...mapState({
      user: state => state.identity.user
    }),
    ...mapState('workflow', {
      objectives: state => state.objectives.items
    }),
    isAdmin() {
      return this.hasRole(this.user, 'ADMIN');
    },
    isOnlyCustomer() {
      return this.hasRole(this.user, 'CUSTOMER');
    },
    isCustomer() {
      return this.isAdmin || this.hasRole(this.user, 'CUSTOMER');
    },
    isProjectManager() {
      return this.isAdmin || this.hasRole(this.user, 'PROJECT_MANAGER');
    },
    isCreator() {
      return this.isAdmin || this.hasRole(this.user, 'CREATOR');
    },
    currentUser() {
      return {
        id: this.user.id,
        name: this.user.full_name,
        companyName: this.user.company,
        email: this.user.email
      };
    }
  },
  methods: {
    removeExtension(value) {
      const reg = new RegExp(/(\.?\w*$)/);
      return value.replace(reg, '');
    },
    isZipFile(file) {
      return file && file.endsWith('.zip') || file.endsWith('.rar');
    },
    detectZipFile(type) {
      return ['octet/stream', 'application/zip', ''].includes(type);
    },
    addSuffix(value, suffix) {
      const reg = new RegExp(/(\.?\w*$)/);
      return value.replace(reg, suffix + '$1');
    },
    showDownloadProcessing() {
      this.showInfo('Your download is being processed and could take few seconds');
    },
    isPending(status) {
      return 'pending' === status;
    },
    hasRole(user, role) {
      return user?.roles?.includes(role) || false;
    },
    isUserCreator(user) {
      return user.roles.includes('ROLE_CREATOR');
    },
    formatBrands(brands) {
      return brands.map(b => b.name).join(', ');
    },
    formatDueDate(dueDate) {
      return !dueDate ? 'due date not defined' : format(parseISO(dueDate), 'PP');
    },
    formatDate(date) {
      return !date ? 'date not defined' : format(parseISO(date), 'PP');
    },
    formatObjective({ type, value }) {
      if (type === 'other') {
        return value;
      } else {
        return this.objectives.find(objective => objective.id === type)?.name;
      }
    },
    async downloadFile(request, filename) {
      try {
        const response = await request;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        this.showError('Error when downloading files');
      }
    },
    showInfo(message) {
      Message.info({
        message
      });
    },
    showSuccess(message) {
      Message.success({
        message
      });
    },
    showError(message) {
      Message.error({
        message
      });
    },
    isFilePreviewable(file) {
      return (
        file &&
        file.url &&
        PREVIEW_FILE_TYPES.includes(
          file.name
            ?.split('.')
            ?.pop()
            ?.toLowerCase()
        )
      );
    }
  }
};
